import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';

@Injectable({
  providedIn: 'root'
})
export class Configurations {
  public createTranslateLoader: (client: HttpClient) => MultiTranslateHttpLoader;
  
  public static serviceLoginCoreEndPoint = 'https://serengeti.aifrica.co.kr/api.login/auth/v1/handle/';

  getLoginEndPoint: () => string;

  public static getServiceLoginEndPoint(config: Configurations) {
    if (config && config.getLoginEndPoint) {
      return config.getLoginEndPoint();
    } else {
      return Configurations.serviceLoginCoreEndPoint;
    }
  }

  constructor() {
    this.createTranslateLoader = null;
  }
}
